export default "/shSMOL.c6f14ae49ff8feed27f45174c00727ae.png";